module.exports = __webpack_public_path__ + "img/newlogoheader.e9bddc3c.svg";